import React from 'react';
import "@fortawesome/fontawesome-free/css/all.min.css";
import { userDefinedRegionUrl, downloadableGISDataUrl, stpDataUrl, serviceCatalogueUrl } from '../../utilities/constants';
import { Link } from 'react-router-dom';

class PaymentResponse extends React.Component {
    constructor(props) {
        super(props);

        var path = this.props.location.pathname;
        var domain = path.split('/');
        var orderIdRandom = domain[domain.length - 1];

        //console.log(orderIdRandom)
        this.state = {
            loading: true,
            orderDetails: {
                Name: "",
                Organization: "",
                EmailAddress: "",
                transactionDate: null,
                transactionExpiryDate: null,
                TotalAmount: "0.00",
                OrderIdRandom: "",
                UserDefinedRegionAmount: "0.00",
                GisDataPurchasedAmount: 0.00,
                stpDataPurchasedAmount: 0.00,
                txnStatus: null
            },

            orderIdRandom: orderIdRandom
        };
    }

    componentDidMount() {
        var myHeaders = new Headers();
        myHeaders.append('pragma', 'no-cache');
        myHeaders.append('cache-control', 'no-cache');
        myHeaders.append('Accept', 'application/json');
        myHeaders.append('Content-Type', 'application/json');

        var myInit = {
            method: 'Get',
            headers: myHeaders
        };

        fetch('api/GetData/GetOrderDetails?orderIdRandom=' + this.state.orderIdRandom, myInit)
            .then(response => response.json())
            .then(data => {
                //console.log({ data });
                this.setState({ orderDetails: data });
                //console.log(this.state.orderDetails.name);
            });
    }

    render() {
        var pymtMethod = this.state.orderDetails.paymentMethod;

        if (pymtMethod === "CC" || pymtMethod === "MO") {
            pymtMethod = "Credit Card";
        } else if (pymtMethod === "DD") {
            pymtMethod = "Direct Debit";
        } else if (pymtMethod === "WA") {
            pymtMethod = "e-Wallet";
        };

        var userDefinedRegionFullUrl = userDefinedRegionUrl + this.state.orderDetails.orderIdRandom;
        var downloadableGISDataFullUrl = downloadableGISDataUrl + this.state.orderDetails.orderIdRandom;
        var stpDataFullUrl = stpDataUrl + this.state.orderDetails.orderIdRandom;

        var status = this.state.orderDetails.txnStatus === "0" ? "successful" : "not successful";

        return (
            <div className="container wow fadeIn pt-4 pb-4">
                <div className="row">
                    <div className="col-lg-12 col-md-12 col-sm-12">
                        <div className="card payment-success-div">
                            <div className="row">
                                <div className="col-lg-3 pl-20 faCheck p-4">
                                    {this.state.orderDetails.txnStatus === "0" && (<i className="far fa-check-circle fa-5x"></i>)}
                                    {this.state.orderDetails.txnStatus === "1" && (<i className="faTimes far fa-times-circle fa-5x"></i>)}
                                </div>
                                <div className="col-lg-8 p-4">
                                    <span className="payment-success">Thank you for the order!</span><br />
                                    <span className="order-placed">Your order has been {status}.</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="row pt-4 pb-4">
                    <div className="col-lg-6 col-md-6 col-sm-6">
                        <div className="card">
                            <div className="">
                                <div className="card">
                                    <div className="">
                                        <div className="card">
                                            <div className="card-header">
                                                <h3 className="panel-title"><strong>Payment Information</strong></h3>
                                            </div>
                                            <ul className="list-group list-group-flush">
                                                <li className="list-group-item d-flex justify-content-between lh-condensed">
                                                    <div>
                                                        <h6 className="my-0">Name</h6>
                                                    </div>
                                                    <span className="text-muted">{this.state.orderDetails.name}</span>
                                                </li>
                                                <li className="list-group-item d-flex justify-content-between lh-condensed">
                                                    <div>
                                                        <h6 className="my-0">Order Number</h6>
                                                    </div>
                                                    <span className="text-muted">{this.state.orderDetails.orderIdRandom}</span>
                                                </li>
                                                <li className="list-group-item d-flex justify-content-between lh-condensed">
                                                    <div>
                                                        <h6 className="my-0">Payment Method</h6>
                                                    </div>
                                                    <span className="text-muted">{this.state.orderDetails.paymentMethod} - {pymtMethod}</span>
                                                </li>
                                                <li className="list-group-item d-flex justify-content-between lh-condensed">
                                                    <div>
                                                        <h6 className="my-0">Payment Status</h6>
                                                    </div>
                                                    <span className="text-muted">{this.state.orderDetails.paymentStatus}</span>
                                                </li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-lg-6 col-md-6 col-sm-6">
                        <div className="card">
                            <div className="">
                                <div className="card">
                                    <div className="">
                                        <div className="card">
                                            <div className="card-header">
                                                <h3 className="panel-title"><strong>Ordered Item</strong></h3>
                                            </div>
                                            <ul className="list-group list-group-flush">

                                                <li className="list-group-item d-flex justify-content-between lh-condensed">
                                                    <div>
                                                        <h6 className="my-0">User Defined Region</h6>
                                                    </div>
                                                    <span className="text-muted">RM {this.state.orderDetails.userDefinedRegionAmount ? this.state.orderDetails.userDefinedRegionAmount : "0.00"}</span>
                                                </li>
                                                <li className="list-group-item d-flex justify-content-between lh-condensed">
                                                    <div>
                                                        <h6 className="my-0">Downloadable GIS Data</h6>
                                                    </div>
                                                    <span className="text-muted">RM {this.state.orderDetails.gisDataPurchasedAmount ? this.state.orderDetails.gisDataPurchasedAmount : "0.00"}</span>
                                                </li>
                                                <li className="list-group-item d-flex justify-content-between lh-condensed">
                                                    <div>
                                                        <h6 className="my-0">STP Data</h6>
                                                    </div>
                                                    <span className="text-muted">RM {this.state.orderDetails.stpDataPurchasedAmount ? this.state.orderDetails.stpDataPurchasedAmount : "0.00"}</span>
                                                </li>

                                                <li className="list-group-item d-flex justify-content-between">
                                                    <span>Total</span>
                                                    <strong>RM {this.state.orderDetails.totalAmount}</strong>
                                                </li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                {this.state.orderDetails.txnStatus === "0" && (
                    <div className="card">
                        <div className="card-header">
                            <strong>You can access your purchase product by link belows :</strong>
                        </div>
                        <ul className="list-group list-group-flush">
                            {this.state.orderDetails.userDefinedRegionAmount ? <li className="list-group-item"> <a href={userDefinedRegionFullUrl} rel="noopener noreferrer" target="_blank" className="card-link">User Defined Region : {userDefinedRegionFullUrl} </a></li> : ""}
                            {this.state.orderDetails.gisDataPurchasedAmount ? <li className="list-group-item"> <a href={downloadableGISDataFullUrl} rel="noopener noreferrer" target="_blank" className="card-link">Downloadable GIS Data: {downloadableGISDataFullUrl} </a></li> : ""}
                            {this.state.orderDetails.stpDataPurchasedAmount ? <li className="list-group-item"> <a href={stpDataFullUrl} rel="noopener noreferrer" target="_blank" className="card-link">STP Data : {stpDataFullUrl} </a></li> : ""}
                        </ul>
                    </div>
                )}

                {this.state.orderDetails.txnStatus === "1" && (
                    <div className="card">
                        <div className="card-header">
                            <strong>Transaction failed</strong>
                        </div>
                        <ul className="list-group list-group-flush">
                            <li className="list-group-item"> The transaction has failed, click <a href={serviceCatalogueUrl} className="card-link">here</a> to return to Service Catalogue page.</li>
                        </ul>
                    </div>
                )}
                <br />

                {this.state.orderDetails.txnStatus === "0" && (
                    <h6>Access to these products will expire on {this.state.orderDetails.transactionExpiryDate}. Please keep these links safely and securely.</h6>
                )}

                <span>You'll receive an email confirmation shortly at <span className="font-weight-bold">{this.state.orderDetails.emailAddress}</span>.</span>

                <div className="col-sm-12 pt-3 text-center">
                    <Link className="" to="/">Go to Home </Link>
                </div> 
            </div>
        )
    }
}

export default PaymentResponse;


// WEBPACK FOOTER //
// ./src/components/Checkout/PaymentResponse.js